import React from "react";
import { bool, func } from "prop-types";

import * as S from "./styled";

const GenericErrorMessage = ({ closeGenericError, visibleGenericError }) => (
  <>
    {visibleGenericError && (
      <S.ErrorContainer>
        <S.ErrorText>
          There was an error sending your request. Please try again.
        </S.ErrorText>
        <S.ErrorCloseX>
          <span
            className="CloseX"
            onClick={closeGenericError}
            onKeyPress={closeGenericError}
            role="button"
            tabIndex={0}
          />
        </S.ErrorCloseX>
      </S.ErrorContainer>
    )}
  </>
);

GenericErrorMessage.propTypes = {
  visibleGenericError: bool.isRequired,
  closeGenericError: func.isRequired
};

export default GenericErrorMessage;
